import api from "./pt-BR/api";
import appName from "./pt-BR/appName";
import auth from "./pt-BR/auth";
import landing from "./pt-BR/landing";
import landingHome from "./pt-BR/landingHome";
import registerTemple from "./pt-BR/registerTemple";
import registerInvite from "./pt-BR/registerInvite";
import verifyEmail from "./pt-BR/verifyEmail";
import onboarding from "./pt-BR/onboarding";
import temple from "./pt-BR/temple";
import agendaPublica from "./pt-BR/agendaPublica";
import common from "./pt-BR/common";
import contacts from "./pt-BR/contacts";
import dashboard from "./pt-BR/dashboard";
import eventTimeline from "./pt-BR/eventTimeline";
import functions from "./pt-BR/functions";
import guides from "./pt-BR/guides";
import home from "./pt-BR/home";
import journeyStages from "./pt-BR/journeyStages";
import membersAssignments from "./pt-BR/membersAssignments";
import menu from "./pt-BR/menu";
import navigation from "./pt-BR/navigation";
import notFound from "./pt-BR/notFound";
import pagination from "./pt-BR/pagination";
import people from "./pt-BR/people";
import personGuides from "./pt-BR/personGuides";
import persons from "./pt-BR/persons";
import ritualAttendance from "./pt-BR/ritualAttendance";
import ritualTypes from "./pt-BR/ritualTypes";
import rituals from "./pt-BR/rituals";
import ritualReservations from "./pt-BR/ritualReservations";
import spiritualLines from "./pt-BR/spiritualLines";
import table from "./pt-BR/table";
import themes from "./pt-BR/themes";
import tickets from "./pt-BR/tickets";
import ticketCall from "./pt-BR/ticketCall";
import attendanceCards from "./pt-BR/attendanceCards";
import attendanceTypes from "./pt-BR/attendanceTypes";
import attendanceOptions from "./pt-BR/attendanceOptions";
import personMessage from "./pt-BR/personMessage";
import personReturn from "./pt-BR/personReturn";
import profile from "./pt-BR/profile";
import ritualClosing from "./pt-BR/ritualClosing";
import users from "./pt-BR/users";
import ownershipTransfer from "./pt-BR/ownershipTransfer";
import tours from "./pt-BR/tours";
import support from "./pt-BR/support";
import displayMessages from "./pt-BR/displayMessages";
import reports from "./pt-BR/reports";
import orixas from "./pt-BR/orixas";
import validation from "./pt-BR/validation";
import phoneField from "./pt-BR/phoneField";
import financial from "./pt-BR/financial";
import import_ from "./pt-BR/import";
import billing from "./pt-BR/billing";
import wisdomQuotes from "./pt-BR/wisdomQuotes";
import memberGroup from "./pt-BR/memberGroup";
import memberHistory from "./pt-BR/memberHistory";
import mfa from "./pt-BR/mfa";
import chat from "./pt-BR/chat";
import session from "./pt-BR/session";

export default {
	relatedEntityCreation: {
		createSpiritualLine: "+ Criar Linha Espiritual",
		createGuide: "+ Criar Guia",
		createAttendanceType: "+ Criar Tipo de Atendimento",
		createRitualType: "+ Criar Tipo de Ritual",
		createMedium: "+ Criar Médium",
	},
	appName,
	api,
	auth,
	landing,
	landingHome,
	registerTemple,
	registerInvite,
	verifyEmail,
	onboarding,
	temple,
	agendaPublica,
	common,
	contacts,
	dashboard,
	eventTimeline,
	functions,
	guides,
	home,
	journeyStages,
	membersAssignments,
	menu,
	navigation,
	notFound,
	pagination,
	people,
	personGuides,
	persons,
	ritualAttendance,
	ritualTypes,
	rituals,
	ritualReservations,
	spiritualLines,
	table,
	themes,
	tickets,
	ticketCall,
	attendanceCards,
	attendanceTypes,
	attendanceOptions,
	personMessage,
	personReturn,
	profile,
	ritualClosing,
	tours,
	support,
	displayMessages,
	reports,
	users,
	ownershipTransfer,
	orixas,
	validation,
	phoneField,
	financial,
	billing,
	import: import_,
	wisdomQuotes,
	memberGroup,
	memberHistory,
	mfa,
	chat,
	session,
};
